import React, { useEffect, useState } from "react";
import styles from "./orders.module.css";
import { Link } from "react-router-dom";
import {
  getDateFromOrder, changeOneDateFormat,
  getStatusName, returnFIO, returnPayer
} from "../../utils/util_functions";
import ProductInOrder from "../product_in_order/product_in_order";
import { useSelector } from "react-redux";
import { STATUSES_VALUES, PAYMENT_STATUSES } from "../../utils/constants";
import { getMyFirms } from "../../services/selectors";



const OrdersItem = ({ order, index, ordersLength }) => {

  const [hidden, setHidden] = useState(true);
  const [statusData, setStatusData] = useState('');

  // const firms = useSelector(getMyFirms);

  // const findFirm = (firmId) => {
  //   const firm = firms.find(firm => firm.id === firmId);
  //   if (firm) {
  //     return firm.name;
  //   }
  //   return 'организация не найдена';
  // }

  // const printPayer = () => {
  //   if (order.firm && order.firm.name) {
  //     return order.firm.name;
  //   }
  //   return 'частное лицо';
  // }

  useEffect(() => {
    setStatusData(changeOneDateFormat(getDateFromOrder(order)));
    // eslint-disable-next-line
  }, [order]);

  return (
    <>
      <tr className={styles.tr}>
        <td className={styles.td__num_data}>
          <Link to={`/orders/${order.id}`} className={styles.link}>
            № {order.id}
          </Link>
          <p className={`${styles.text} ${styles.text__date}`}>
            {changeOneDateFormat(order.created_date)}
          </p>
        </td>
        <td className={styles.td__status}>
          <p
            className={`
              ${styles.text}
              ${order.status === STATUSES_VALUES.cancelled && styles.text__red}
              ${order.status === STATUSES_VALUES.received && styles.text__green}
              ${order.status === STATUSES_VALUES.created && styles.text__bold}
            `}
          >
            {getStatusName(order.status)}
          </p>
          {order.status !== STATUSES_VALUES.created &&
            <p className={styles.text}>{statusData}</p>
          }
        </td>
        <td className={styles.td__sum}>
          <p className={styles.text}>{order.total_price.toLocaleString()}  &#8381;</p>
          <p
            className={styles.text_button}
            onClick={() => setHidden(!hidden)}
          >
            {hidden ? 'Показать' : 'Скрыть'}
          </p>
        </td>
        <td className={styles.td__payed}>

          <p className={`${styles.text} ${(order.total_paid < order.total_price) && 'red' }`}>
            {PAYMENT_STATUSES.find(item => item.value === order.payment_status).name}
          </p>
        </td>
        <td className={styles.td__customer}>
          <p className={styles.text}>
            {/* {order.firm ? findFirm(order.firm) :
              `${order.customer.last_name} ${order.customer.first_name} ${order.customer.surname}`
            } */}
            {returnPayer(order)}
          </p>
        </td>
      </tr>
      {!hidden &&
        <tr className={styles.tr}>
          <td colSpan={8} className={styles.td__structure}>
            <ProductInOrder productsinorder_set={order.productsinorder_set} />
          </td>
        </tr>
      }
      {(index !== ordersLength - 1) &&
        <tr className={styles.tr}>
          <td colSpan={8} className={styles.line}></td>
        </tr>
      }
    </>
  )
};

export default OrdersItem;
